import React, { useContext, useState } from 'react'
import { Popup } from '../../components/Popup'
import PrivatePage from '../../components/PrivatePage'
import { languageTranslationObject } from '../../languages'
import { AccountContext } from '../../providers/accountProvider'

import {
  FaqContainer,
  FrequentlyAskedQuestionsHeading,
  Accordion,
  AccordionBtn,
  AccordionContainer,
  AccordionText,
  FAQSectionHead,
} from './style'

export default function Faq({ ...props }) {
  const { user } = useContext(AccountContext)
  const userLanguage = user.languages
  const isLanguagePresent = ['hindi', 'english', 'tamil'].includes(userLanguage)
  let language = isLanguagePresent ? userLanguage : 'english'
  if (user.location === 'US' && language === 'english') language = 'englishUS'
  const translation = { ...languageTranslationObject[language] }
  const [videoLink, setVideoLink] = useState('')
  const [ytIframeVideoCode, setYtIframeVideoCode] = useState('')
  
  const toggleAccordionTextHandler = (e) => {
    const accordionTextElement = e.currentTarget.nextElementSibling
    if (accordionTextElement.tagName === 'DIV') {
      e.currentTarget.classList.toggle('open')
      accordionTextElement.style.maxHeight
        ? (accordionTextElement.style.maxHeight = null)
        : (accordionTextElement.style.maxHeight =
            accordionTextElement.scrollHeight + 'px')
    }
  }
  const videoLinkHandler = (videoCode) => {
    setVideoLink(videoCode)
  }
  const youTubeLinkHandler = (videoCode) => {
    setYtIframeVideoCode(videoCode)
  }

  const FAQAccordianContainer = ({ type }) => {
    return (
      <AccordionContainer>
        {translation[type].map((data, index) => (
          <Accordion key={index}>
            <AccordionBtn onClick={toggleAccordionTextHandler}>
              {data.question}
            </AccordionBtn>
            <AccordionText>
              <span dangerouslySetInnerHTML={{ __html: data.answer }}></span>
              {data.youtubeLink && (
                <span
                  style={{ color: 'blue', cursor: 'pointer' }}
                  onClick={() => videoLinkHandler(data.youtubeLink)}
                >
                  here
                </span>
              )}
            </AccordionText>
          </Accordion>
        ))}
      </AccordionContainer>
    )
  }

  if (language === 'hindi' || language === 'englishUS') {
    return (
      <PrivatePage>
        <FaqContainer>
          {' '}
          <FrequentlyAskedQuestionsHeading>
            {translation.faq}
            <span role="img" aria-label="question">
              ❓
            </span>
            {videoLink && (
              <Popup
                show
                close={() => setVideoLink('')}
                className={'wbp_video'}
              >
                <div
                  style={{
                    width: '80vw',
                    height: '80vh',
                    margin: 'auto',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <div
                    style={{
                      position: 'absolute',
                      color: '#464646',
                      fontSize: '100px',
                      top: '0',
                      right: '0',
                      zIndex: '2',
                      cursor: 'pointer',
                      lineHeight: '44px',
                      margin: '40px',
                    }}
                    onClick={() => setVideoLink('')}
                  >
                    ˟
                  </div>
                  {!videoLink.includes('cloudfront') && (
                    <iframe
                      style={{
                        height: '100%',
                        width: '100%',
                      }}
                      src={`https://www.youtube.com/embed/${videoLink}?autoplay=1`}
                      title="YouTube video player"
                      frameborder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowfullscreen="true"
                    ></iframe>
                  )}
                  
                </div>
              </Popup>
            )}
          </FrequentlyAskedQuestionsHeading>
          <FAQSectionHead>Writing</FAQSectionHead>
          <FAQAccordianContainer type={'WritingFAQs'} />
          <FAQSectionHead>Program</FAQSectionHead>
          <FAQAccordianContainer type={'ProgramFAQs'} />
          <FAQSectionHead>Platform</FAQSectionHead>
          <FAQAccordianContainer type={'PlatformFAQs'} />
          <FAQSectionHead>Issues</FAQSectionHead>
          <FAQAccordianContainer type={'IssuesFAQs'} />
        </FaqContainer>
      </PrivatePage>
    )
  }
  return (
    <PrivatePage>
      <FaqContainer>
        {' '}
        <FrequentlyAskedQuestionsHeading>
          {translation.faq}
          <span role="img" aria-label="question">
            ❓
          </span>
        </FrequentlyAskedQuestionsHeading>
        {ytIframeVideoCode && (
          <Popup
            show
            close={() => setYtIframeVideoCode('')}
            className={'YouTube_Iframe'}
            closeMarksStyles={{ top: '20%' }}
          >
            <div style={{ position: 'relative', paddingBottom: '56.25%' }}>
              <iframe
                style={{
                  position: 'absolute',
                  top: '0',
                  left: '0',
                  height: '100%',
                  width: '100%',
                }}
                src={`https://www.youtube.com/embed/${ytIframeVideoCode}?autoplay=1`}
                title="YouTube video player"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </Popup>
        )}
        <AccordionContainer>
          {translation.frequentlyAskedQuestionsArray.map((data, index) => (
            <Accordion key={index}>
              <AccordionBtn onClick={toggleAccordionTextHandler}>
                {data.question}
              </AccordionBtn>
              <AccordionText>
                <span dangerouslySetInnerHTML={{ __html: data.answer }}></span>
                {data.youtubeLink && (
                  <span
                    style={{ color: 'blue', cursor: 'pointer' }}
                    onClick={() => youTubeLinkHandler(data.youtubeLink)}
                  >
                    here
                  </span>
                )}
              </AccordionText>
            </Accordion>
          ))}
        </AccordionContainer>
      </FaqContainer>
    </PrivatePage>
  )
}
